import { v4 as uuidv4 } from 'uuid';

import { RTMP_PORT } from '../../constants';

export const createLiveStreamId = (): string => {
  const uuid = uuidv4();
  return `livestream:${uuid}`;
};

export const createLiveStreamUrl = (url: string, key?: string): string => {
  if (!key) {
    return url;
  }
  return `${url.replace(/\/$/, '')}/${key}`;
};

export const formatLiveStreamUrl = (url?: string): string => {
  if (!url) {
    return '';
  }
  const host = url.split('/')[2];
  return `rtmp://${host}:${RTMP_PORT}/live`;
};

export const parseLiveStreamKey = (url: string): string => {
  let key = '';
  if (url.includes('live/')) {
    key = url.substring(url.lastIndexOf('/') + 1);
  }
  return key;
};
